const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-directives');
/**
 * Defines the users workshop status component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {userWorkshops} userWorkshops the resource defined to manage userWorkshops
 */
app.directive('userWorkshopsStatus', ['Authorization', 'UserWorkshops', function (Authorization, UserWorkshops) {
    return {
      restrict: 'E',
      template: require('../../templates/directives/user-workshops-status.html'),
      controller: function () {
        var self = this;
        self.dropLocation = false;
        self.currentTab = 'scheduled';
        self.futureWorkshops = [];
        self.pastWorkshops = [];

        var sort = function(a, b, type) {
          if (!a.workshop_instance || !a.workshop_instance.start_date || !b.workshop_instance || !b.workshop_instance.start_date) {
            return 0;
          }
          if (new Date(a.workshop_instance.start_date) < new Date(b.workshop_instance.start_date)) {
            return 1 * type;
          }
          if (new Date(a.workshop_instance.start_date) > new Date(b.workshop_instance.start_date)) {
            return -1 * type;
          }
          return 0;
        };

        self.parseUserWorkshops = function(data) {
          data.sort(function(a, b) {
            if (!a.workshop_instance || !a.workshop_instance.start_date || !b.workshop_instance || !b.workshop_instance.start_date) {
              return 0;
            }
            if (new Date(a.workshop_instance.start_date) < new Date(b.workshop_instance.start_date)) {
              return 1;
            }
            if (new Date(a.workshop_instance.start_date) > new Date(b.workshop_instance.start_date)) {
              return -1;
            }
            return 0;
          });
          data.forEach(function(item) {
            if (item.active_status === 'attended') {
              self.pastWorkshops.push(item);
              return;
            }
            if (item.active_status === 'registered') {
              var start = item.workshop_instance && item.workshop_instance.start_date || null;
              if (start && new Date(start) < new Date()) {
                self.pastWorkshops.push(item);
                return;
              }
              self.futureWorkshops.unshift(item);
            }
          })
        };

        self.initialize = function () {
          self.loading = true;
          UserWorkshops.find({
            fields: 'user,active_status,workshop,workshop_instance',
            user: Authorization.getAuthToken().user._id,
            active_status: '$in,2,registered,attended',
            'workshop-populate': 'title,image,banner_image,type',
            'workshop_instance-populate': 'start_date,end_date,location,online,online_location,online_location_label,recordings'
          }, function (data) {
            self.parseUserWorkshops(data);
            self.loaded = true;
            self.loading = false;
          }, function (error) {
            console.log('Error occured getting user workshops ', error);
          });
        };

        self.initialize();
      },
      controllerAs: 'workshopsStatus'
    };
  }]);
